// extracted by mini-css-extract-plugin
export default {"spinner-content":"IpaAdministrationWizard_spinner-content__GdBxe","spinner":"IpaAdministrationWizard_spinner__d1U1u"};